module.exports = __webpack_public_path__ + "img/portrait-071.06c3943b.jpg";